import React, { Component } from 'react';
import { connect } from 'react-redux';
import { withTranslation } from 'react-i18next';
import { QRCodeSVG } from 'qrcode.react';

class POSPrintReceipt extends Component {
    constructor(props, context) {
        super(props, context);
    }

    render() {
        const { t } = this.props;
        const p = this.props;
        const line = '-------------------------------------------------------';
        const width = '280px';
        const style = {
            width: width,
            height: 'auto'
        };
        const inline = {
            display: 'inline'
        }
        let totalDiscountsOnProducts = p.order && p.order.products ? p.order.products.reduce((sum, product) => {
            const productSum = product.productDiscountList.reduce((subsum, discount) => subsum + discount.amount, 0);
            return sum + productSum;
        }, 0) : 0;

        let totalDiscountsOnOrder = p.order && p.order.discounts ? p.order.discounts.reduce((sum, discount) => sum + discount.amount, 0) : 0;

        let totalDiscounts = totalDiscountsOnProducts + totalDiscountsOnOrder;

        let memberSavings = p.order && p.order.products
            ? p.order.products.reduce((sum, x) =>
                (x.status === 1 || x.status === 2)
                    ? sum + (x.originalNonMemberPrice - x.price)
                    : sum
                , 0)
            : 0;

        return p.order ? (
            <div id={p.name} style={{ display: 'none' }}>
                <div style={style} id={p.name + '-content'} className="printable">
                    <div className="row">
                        <div className="col-lg-12">
                            <p className="text-center">{p.store.name}</p>
                            <p className="text-center">{p.store.site}</p>
                            <p className="text-center">{p.store.street}</p>
                            <p className="text-center">{p.store.city}, {p.store.provinceState} {p.store.postalCode}, {p.store.country}</p>
                            <p className="text-center">{p.store.phone}</p>
                            {this.props.showEmployeeNameOnReceipt &&
                                <p className="text-center">{this.props.receiptShowEmployeeFirstName ? p.order.employeeFirstName : ""} {this.props.receiptShowEmployeeLastName ? p.order.employeeLastName : ""}</p>
                            }
                            <br />
                            {
                                p.order && p.order.patientId > 0 ? (
                                    <div>
                                        <p>{t('pos.printReceipt.patient')} #{p.order.patientId}</p>
                                        {
                                            p.order.patientPoints ?
                                                (<p>{t('pos.printReceipt.points')}: XXXX</p>) : null
                                        }
                                    </div>
                                ) : null
                            }
                            <br />
                            <p>{new Date().toDateString() + ' ' + new Date().toTimeString().slice(0, 5)}</p>
                            <div>
                                <table style={{ border: 'none', width: width }}>
                                    <tbody>
                                        {
                                            p.order && p.order.products ? (
                                                p.order.products.map((item, index) => {
                                                    let hasDiscounts = item.productDiscountList ? item.productDiscountList.length > 0 : 0
                                                    if (item.status !== 2)
                                                        return null;
                                                    if (item.isUnitProduct)
                                                        return (
                                                            <tr key={index}>
                                                                <td colSpan="3">
                                                                    <span className="pull-left">{item.quantity}X {item.name}</span>
                                                                    {
                                                                        item.quantity > 1 ? (
                                                                            <span>&nbsp;&nbsp;&nbsp;@${item.pricePerUnit.toFixed(2)} {t('pos.printReceipt.eachUpper')}</span>
                                                                        ) : null
                                                                    }
                                                                </td>
                                                                <td><span className="pull-right">${item.price.toFixed(2)}</span></td>
                                                                {
                                                                    hasDiscounts && item.productDiscountList.map((discount, ind) => {
                                                                        return (
                                                                            <tr key={ind}>
                                                                                <td colSpan="2" className="pull-left">&nbsp;&nbsp;&nbsp;{discount.text}:  -${discount.amount.toFixed(2)}</td>
                                                                            </tr>
                                                                        )

                                                                    })
                                                                }
                                                            </tr>
                                                        );
                                                    return (
                                                        <tr key={index}>
                                                            <td colSpan="3"><span className="pull-left">{item.quantity}gX {item.name}</span></td>
                                                            <td style={inline}><span className="pull-right">${item.price.toFixed(2)}</span></td>
                                                            {
                                                                hasDiscounts && item.productDiscountList.map((discount, ind) => {
                                                                    return (
                                                                        <tr key={ind}>
                                                                            <td colSpan="2" className="pull-left">&nbsp;&nbsp;&nbsp;{discount.text}:  -${discount.amount.toFixed(2)}</td>
                                                                        </tr>
                                                                    )

                                                                })

                                                            }
                                                        </tr>
                                                    );
                                                })
                                            ) : null
                                        }
                                        <tr><td colSpan="4">{line}</td></tr>
                                        <tr>
                                            <td colSpan="1"><span className="pull-right">{t('pos.printReceipt.subtotal')}: </span></td>
                                            <td colSpan="3"><span className="pull-right">${p.order.subTotal.toFixed(2)}</span></td>
                                        </tr>
                                        {
                                            p.order.discounts ? p.order.discounts.map((item, ind) => {
                                                return (
                                                    <tr key={ind}>
                                                        <td colSpan="3"><span className="pull-right">{item.text} </span></td>
                                                        <td><span className="pull-right">-${item.amount.toFixed(2)}</span></td>
                                                    </tr>
                                                )

                                            }) : null
                                        }
                                        {
                                            totalDiscountsOnProducts != 0 &&
                                            <tr>
                                                <td colSpan="3"><span className="pull-right">{t('pos.printReceipt.totalProdDiscount')}: </span></td>
                                                <td><span className="pull-right">-${totalDiscountsOnProducts.toFixed(2)}</span></td>
                                            </tr>
                                        }
                                        {
                                            totalDiscounts != 0 &&
                                            <tr>
                                                <td colSpan="3"><span className="pull-right">{t('pos.printReceipt.totalDiscount')}: </span></td>
                                                <td><span className="pull-right">-${totalDiscounts.toFixed(2)}</span></td>
                                            </tr>
                                        }
                                        {
                                            p.order.subTotalIncludingDiscounts != p.order.subTotal &&
                                            <tr>
                                                <td colSpan="3"><span className="pull-right">{t('pos.printReceipt.subtotalIncludingDiscount')}: </span></td>
                                                <td><span className="pull-right">${p.order.subTotalIncludingDiscounts.toFixed(2)}</span></td>
                                            </tr>
                                        }
                                        {
                                            p.order.taxesRate ? p.order.taxesRate.map((tax, index) => {
                                                return (
                                                    <tr key={index}>
                                                        <td colSpan="3"><span className="pull-right">{tax.name}: </span></td>
                                                        <td><span className="pull-right">${tax.value.toFixed(2)}</span></td>
                                                    </tr>
                                                );
                                            }) : null
                                        }
                                        <tr>
                                            <td colSpan="3"><span className="pull-right">{t('pos.printReceipt.total')}: </span></td>
                                            <td><span className="pull-right">${p.order.total.toFixed(2)}</span></td>
                                        </tr>
                                        <tr>
                                            <td colSpan="3"><span className="pull-right">{t('pos.printReceipt.paid')}: </span></td>
                                            <td><span className="pull-right">${p.order.paid.toFixed(2)}</span></td>
                                        </tr>
                                        <tr>
                                            <td colSpan="3"><span className="pull-right">{t('pos.printReceipt.due')}: </span></td>
                                            <td><span className="pull-right">${p.order.balanceDue.toFixed(2)}</span></td>
                                        </tr>
                                        <tr>
                                            <td colSpan="3"><span className="pull-right">{t('pos.printReceipt.change')}: </span></td>
                                            <td><span className="pull-right">${p.order.change.toFixed(2)}</span></td>
                                        </tr>
                                        <tr>
                                            <td colSpan="3"><span className="pull-right">{t('pos.printReceipt.tips')}: </span></td>
                                            <td><span className="pull-right">${p.order.tipAmount ? p.order.tipAmount.toFixed(2) : "0.00"}</span></td>
                                        </tr>
                                        {
                                            p.order.payments ? (
                                                <tr>
                                                    <td colSpan="4"><span>{t('pos.printReceipt.paymentReceived')}:</span></td>
                                                </tr>
                                            ) : null
                                        }
                                        {
                                            p.order.payments ? p.order.payments.map((payment, index) => {
                                                return (
                                                    <tr key={index}>
                                                        <td colSpan="3"><span className="pull-right">{payment.name}: </span></td>
                                                        <td><span className="pull-right">${payment.value.toFixed(2)}</span></td>
                                                    </tr>
                                                );
                                            }) : null
                                        }
                                        {
                                            p.order.hasRefunds ? (
                                                <tr>
                                                    <td colSpan="3"><span className="pull-right">{t('pos.printReceipt.refund')}: </span></td>
                                                    <td><span className="pull-right">${p.order.refund.toFixed(2)}</span></td>
                                                </tr>
                                            ): null
                                        }
                                        {
                                            (p.showMemberSavings && memberSavings != 0) ? (
                                                <tr>
                                                    <td colSpan="3"><span className="pull-right">{t('pos.orderSummary.memberSavings')}: </span></td>
                                                    <td><span className="pull-right">${memberSavings.toFixed(2)}</span></td>
                                                </tr>
                                            ) : null
                                        }
                                    </tbody>
                                </table>

                            </div>
                            <p style={{ width: width }}>{line}</p>
                            <p className="text-center">{new Date().toDateString() + ' ' + new Date().toTimeString().slice(0, 5)}</p>
                            {
                                p.order && p.order.id > 0
                                    ? (<p className="text-center" style={{ fontSize: '12px' }}>{t('common.order')} #{p.order.id}</p>)
                                    : null
                            }
                            <p style={{ width: width }}>{line}</p>
                            {
                                p.fianlSaleTextShowOnReceipt && (
                                    <div>
                                        <p className="text-center">{t('pos.printReceipt.allSaleFinal')}</p>
                                        <p className="text-center">{t('pos.printReceipt.thanks')}</p>
                                    </div>
                                )
                            }
                            <p style={{ width: width }}>{line}</p>
                            <p className="text-center">{t('pos.printReceipt.poweredByTechPOS')}</p>

                            <br />
                            {/* <p className="text-center">
                                
                                {p.order && p.order.qrCode && <React.Fragment>
                                    {!p.order.qrCode.includes(`TSS-JWToken`) ? <QRCodeSVG value={p.order.qrCode[p.order.qrCode.length-1]} size={128} /> : p.order.qrCode} 
                                    
                                </React.Fragment>}
                               
                            </p> */}
                        </div>
                    </div>
                </div >
            </div >
        ) : null;
    }
}


function mapStateToProps(state) {
    return {
        store: state.common.store,
        showEmployeeNameOnReceipt: state.common.applicationSettings.showEmployeeNameOnReceipt,
        receiptShowEmployeeFirstName: state.common.applicationSettings.receiptShowEmployeeFirstName,
        receiptShowEmployeeLastName: state.common.applicationSettings.receiptShowEmployeeLastName,
    };
}

export default connect(mapStateToProps)(withTranslation()(POSPrintReceipt));